/* eslint-disable */
import React from 'react';
import LegalPage from '../components/LegalPage';

const PrivacyPolicy = () => (
  <LegalPage eyebrow="YOUR PRIVACY" title="Privacy" italicTail="Policy.">
    <p>Velouva values your privacy and is committed to protecting your personal information.</p>

    <h2>Information We Collect</h2>
    <p>We may collect:</p>
    <ul>
      <li>Name</li>
      <li>Email address</li>
      <li>Mobile number</li>
      <li>Shipping and billing address</li>
      <li>Payment information (processed securely through payment partners)</li>
      <li>Device and browsing information</li>
    </ul>

    <h2>How We Use Your Information</h2>
    <p>We use your information to:</p>
    <ul>
      <li>Process orders</li>
      <li>Deliver products</li>
      <li>Provide customer support</li>
      <li>Send order updates</li>
      <li>Improve our website and services</li>
      <li>Send promotional communications (with your consent)</li>
    </ul>

    <h2>Data Security</h2>
    <p>We implement reasonable security measures to protect your personal information.</p>

    <h2>Sharing Information</h2>
    <p>We do not sell customer information. Information may be shared with:</p>
    <ul>
      <li>Courier partners</li>
      <li>Payment gateway providers</li>
      <li>Service providers assisting in website operations</li>
    </ul>

    <h2>Cookies</h2>
    <p>We may use cookies and analytics tools to improve website performance and customer experience.</p>

    <h2>Contact</h2>
    <p>For privacy-related concerns, email <a href="mailto:service@velouva.in">service@velouva.in</a>.</p>
  </LegalPage>
);

export default PrivacyPolicy;
